import { ApolloLink } from '@apollo/client';
/**
 * Creates an authentication link that adds request headers to each operation.
 * The link retrieves headers from the provided APIHelper and merges them with any existing headers.
 *
 * @param APIHelper - Object with getRequestHeaders method for generating authentication headers
 * @returns ApolloLink instance that adds authentication headers to operations
 */
export const createAuthLink = (APIHelper) => new ApolloLink((operation, forward) => {
    const context = operation.getContext();
    const originalHeaders = context.headers || {};
    const { headers } = APIHelper.getRequestHeaders(!context.skipAuthentication, {
        operationName: operation.operationName,
    }, context.customAccessToken);
    operation.setContext({
        headers: {
            ...originalHeaders,
            ...headers,
        },
    });
    return forward(operation);
});
